import { validateMobileDeepLink, validateUrlLink } from '../../../utils';

export type FormValues = {
  redirect_uris: string[];
  name: string;
  is_public: string;
  merchant_project_id: string;
  lifetime: number;
};

type FormValuesValidate = {
  redirect_uris: string[] | string;
  name?: string;
  is_public?: string;
  lifetime?: string;
};

export const clientNameMaxLength = 255;

const validateUris = (linkString: string) =>
  validateUrlLink(linkString) || validateMobileDeepLink(linkString);

export const Oauth2ModalValidator = (values: FormValues): FormValuesValidate => {
  const errors: FormValuesValidate = {
    redirect_uris: []
  };
  if (!values.name) {
    errors.name = 'app.validation.required';
  }
  if (values.name && values.name.length > clientNameMaxLength) {
    errors.name = 'app.validation.characters';
  }
  if (values.is_public !== 'server') {
    if (values.redirect_uris.length === 0) {
      errors.redirect_uris = 'app.validation.required';
    } else if (values.redirect_uris.filter((i) => !!i).length) {
      const accum = Object.create(null);

      errors.redirect_uris = values.redirect_uris.map((fieldValue) => {
        const urlErr =
          !validateUris(fieldValue) && 'authorization.settings.oauth2.validation.invalid-url';
        const duplicateErr =
          accum[fieldValue] && 'authorization.settings.oauth2.validation.duplicate-url';
        accum[fieldValue] = true;

        return urlErr || duplicateErr;
      });
    } else {
      errors.redirect_uris = values.redirect_uris.map(() => 'app.validation.required');
    }
  }
  if (!values.lifetime) {
    errors.lifetime = 'app.validation.required';
  }
  if (Number(values.lifetime) < 300) {
    errors.lifetime = 'app.validation.value-less';
  }
  if (Number(values.lifetime) > 1893456000) {
    errors.lifetime = 'app.validation.value-more';
  }
  return errors;
};
